import { useRef } from 'react';
/**
 * Creates an immutable function reference. Used to limit re-renders and to
 * create a closure for local variables.
 */
export const useFn = (fn) => {
    const fnRef = useRef(fn);
    fnRef.current = fn;
    return useRef((...args) => fnRef.current(...args)).current;
};
//# sourceMappingURL=useFn.js.map